import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ThemeType } from '@services/theme.service';

@Component({
	selector: 'cstmsr-tab-container',
	imports: [CommonModule],
	templateUrl: './tab-container.component.html',
	styleUrl: './tab-container.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true
})
export class TabContainerComponent {

	@Input() tabs: TabViewModel[] = [];
	@Input() mini: boolean = false;

	@Input() activeTab: TabViewModel | undefined = undefined;

	@Input() useMargin: boolean = true;

	@Output() activeTabChanged: EventEmitter<TabViewModel> = new EventEmitter<TabViewModel>()

	setActiveTab(tab: TabViewModel) {
		if (this.activeTab !== tab) {
			this.activeTab = tab;
			this.activeTabChanged.emit(tab);
		}
	}
}

export interface TabViewModel {
	name: string;
	display: string;
	theme: ThemeType
}
